import { useState, useEffect } from "react";
import { Outlet, NavLink, useLocation, useNavigate } from "react-router-dom";
import "./SidebarV2.css";
import { FaBars } from "react-icons/fa6";
import {
    MdOutlineDashboard,
    MdOutlineKeyboardArrowDown,
    MdOutlineKeyboardArrowUp,
} from "react-icons/md";
import { Dropdown } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../../Redux/authSlice";
import { ImSwitch } from "react-icons/im";




export default function SidebarV2({ navItems }) {
    const [search, setSearch] = useState("");
    const [collapsed, setCollapsed] = useState(false);
    const [open, setOpen] = useState(false);
    const [openMenu, setOpenMenu] = useState(null);

    const location = useLocation();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const handleLogout = () => {
        dispatch(logout());
        navigate("/");
    };
    const role = useSelector(state => state.auth.role);
    const user = useSelector(state => state.auth.user);
    const userName = useSelector(state => state.auth.userName);
    const companyName = useSelector(state => state.auth.companyName);


    const [isMobile, setIsMobile] = useState(window.innerWidth <= 992);


    // ✅ AUTO OPEN DROPDOWN ON ROUTE
    useEffect(() => {
        navItems.forEach((item) => {
            if (item.children) {
                const match = item.children.find((c) =>
                    location.pathname.includes(c.path)
                );
                if (match) {
                    setOpenMenu(item.id);
                }
            }
        });
    }, [location.pathname]);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 992);
        };

        window.addEventListener("resize", handleResize);

        return () => window.removeEventListener("resize", handleResize);
    }, []);

    // ✅ TOGGLE
    const handleToggle = () => {
        if (isMobile) {
            setOpen(prev => !prev);
        } else {
            setCollapsed(prev => !prev);
        }
    };

    return (
        <div className="oms-root">
            <div className="oms-layout">

                {/* MOBILE OVERLAY */}
                {open && isMobile && (
                    <div
                        className="oms-overlay-bg"
                        onClick={() => setOpen(false)}
                    />
                )}

                {/* SIDEBAR */}
                <aside
                    className={`oms-sidebar ${collapsed ? "collapsed" : ""} ${open ? "open" : ""
                        }`}
                >
                    {/* LOGO */}

                    {collapsed ? (
                        <div className="oms-logo">
                            <div className="oms-logo-mark">

                                <div className="oms-avatar text-uppercase py-0">
                                    AR
                                </div>
                            </div>

                        </div>
                    ) : (
                        <div className="oms-logo">
                            <div className="oms-logo-mark">
                                AR<span>.</span>GROUP
                            </div>
                            <div className="oms-logo-sub">Order Management</div>

                        </div>
                    )
                    }



                    {/* NAV */}
                    <nav className="oms-nav">
                        <div className="oms-nav-label">Main Menu</div>

                        {navItems.map((n) => (
                            <div key={n.id}>

                                {/* ===== SIMPLE LINK ===== */}
                                {!n.children ? (
                                    <NavLink
                                        to={n.path}
                                        className={({ isActive }) =>
                                            `oms-nav-item ${isActive ? "active" : ""} text-decoration-none`

                                        }
                                        onClick={() => {
                                            if (window.innerWidth <= 992) setOpen(false);
                                        }}
                                    >
                                        <span className="oms-nav-icon">{n.icon}</span>
                                        {!collapsed && n.label}
                                    </NavLink>
                                ) : (
                                    <>
                                        {/* ===== PARENT ===== */}
                                        <div
                                            className={`oms-nav-item ${openMenu === n.id ? "active" : ""
                                                }`}
                                            onClick={() =>
                                                setOpenMenu(openMenu === n.id ? null : n.id)
                                            }
                                        >
                                            <span className="oms-nav-icon">{n.icon}</span>

                                            {!collapsed && (
                                                <>
                                                    {n.label}
                                                    <span style={{ marginLeft: "auto" }}>
                                                        {openMenu === n.id ? (
                                                            <MdOutlineKeyboardArrowUp />
                                                        ) : (
                                                            <MdOutlineKeyboardArrowDown />
                                                        )}
                                                    </span>
                                                </>
                                            )}
                                        </div>

                                        {/* ===== SUB MENU ===== */}
                                        {openMenu === n.id && !collapsed && (
                                            <div className="oms-submenu">
                                                {n.children.map((child) => (
                                                    <NavLink
                                                        key={child.id}
                                                        to={child.path}
                                                        className={({ isActive }) =>
                                                            `oms-submenu-item ${isActive ? "active" : ""
                                                            }`
                                                        }
                                                        onClick={() => {
                                                            if (window.innerWidth <= 992) setOpen(false);
                                                        }}
                                                    >
                                                        {child.label}
                                                    </NavLink>
                                                ))}
                                            </div>
                                        )}
                                    </>
                                )}
                            </div>
                        ))}
                    </nav>

                    {/* USER */}
                    <div className="oms-sidebar-footer">
                        <div className="oms-user-card">
                            <div className="oms-avatar text-uppercase">
                                {`${user?.firstName?.charAt(0) || ""}${user?.lastName?.charAt(0) || ""}`}
                            </div>
                            {!collapsed && (
                                <div>
                                    {/* <div className="oms-user-name text-capitalize">{`${user?.firstName} ${user?.lastName}`}</div> */}
                                    <div className="oms-user-name text-capitalize">{user?.userName}</div>
                                    <div className="oms-user-role text-capitalize">{role}</div>
                                </div>
                            )}
                        </div>
                    </div>
                </aside>

                {/* MAIN */}
                <main className="oms-main">

                    {/* TOPBAR */}
                    <div className="oms-topbar">
                        <FaBars onClick={handleToggle} size={22} />

                        <div className="oms-topbar-title text-white">

                            <span>
                                {/* {new Date().toLocaleDateString("en-PK", {
                                    weekday: "long",
                                    year: "numeric",
                                    month: "long",
                                    day: "numeric",
                                })} */}
                                {companyName}
                            </span>
                        </div>




                        <Dropdown align="end">
                            <Dropdown.Toggle

                                id="dropdown-user"
                                className="oms-user-toggle "
                            >

                                {role === "superadmin" || role === "superAdmin" ? (
                                    <div className="d-flex align-items-center gap-2">
                                        <div className="oms-avatar text-uppercase">
                                            SA
                                        </div>
                                        <div className="text-start">
                                            {/* <div className="oms-user-name text-capitalize">{`${user?.firstName} ${user?.lastName}`} */}
                                            <div className="oms-user-name text-capitalize">
                                                {/* {user?.userName} */}
                                                Super Admin
                                                <div className="oms-user-role text-capitalize">{role}</div>
                                            </div>
                                        </div>
                                    </div>
                                ) :
                                    (<div className="d-flex align-items-center gap-2">
                                        <div className="oms-avatar text-uppercase">
                                            {`${user?.firstName?.charAt(0) || ""}${user?.lastName?.charAt(0) || ""}`}
                                        </div>
                                        <div className="text-start">
                                            {/* <div className="oms-user-name text-capitalize">{`${user?.firstName} ${user?.lastName}`} */}
                                            <div className="oms-user-name text-capitalize">
                                                {user?.userName}

                                                <div className="oms-user-role text-capitalize">{role}</div>
                                            </div>
                                        </div>
                                    </div>)
                                }

                            </Dropdown.Toggle>

                            <Dropdown.Menu className="oms-user-dropdown-menu">
                                <Dropdown.Item>👤 Profile</Dropdown.Item>
                                <Dropdown.Item>⚙ Settings</Dropdown.Item>
                                <Dropdown.Item>🔒 Change Password</Dropdown.Item>
                                <Dropdown.Divider />
                                <Dropdown.Item onClick={handleLogout} className="text-danger">
                                    <ImSwitch size={14} className="me-2" />
                                    Logout</Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>

                    </div>

                    {/* CONTENT */}
                    <div className="oms-content">
                        <Outlet />
                    </div>
                </main>
            </div>
        </div>
    );
}